import { parseDateWithFormat } from '../common/helpers/formatDate';
import { getNextSortConfig } from '../Report/dailySaleReportTableConfig';
import { posquotation_head } from '../../components/common/Tablehead';

export { getNextSortConfig };

/** Column index → quotation list row field. Index 0 (#) and 10 (Action) are not sortable. */
export const QUOTATION_COLUMN_FIELDS = [
  null,
  'date',
  'type',
  'voucher_type',
  '__ref_quo__',
  'customer',
  'SKU',
  'location',
  'qty',
  'amount',
  null,
];

const NUMERIC_FIELDS = new Set(['SKU', 'qty', 'amount']);

const getSortValue = (row, field) => {
  if (field === '__ref_quo__') {
    const refNo = row?.ref_no ? String(row.ref_no).trim() : '';
    const quoNo = row?.quo_no ? String(row.quo_no).trim() : '';
    const combined = [refNo, quoNo].filter(Boolean).join(' ');
    return combined ? combined.toLowerCase() : null;
  }

  const value = row?.[field];
  if (value === null || value === undefined || value === '') return null;
  if (field === 'date') return parseDateWithFormat(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === 'number' && typeof right === 'number') {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: 'base',
    numeric: true,
  });
};

export const sortQuotationRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = QUOTATION_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === 'desc' ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};

export const normalizeQuotationTableHead = (columns) => {
  if (!Array.isArray(columns) || !columns.length) return posquotation_head;

  const withoutQuoNo = columns.filter(
    (col) =>
      col?.name !== 'Quo No.' &&
      col?.lable !== 'Quo No.' &&
      col?.name !== 'Quo No' &&
      col?.lable !== 'Quo No'
  );

  const renamedColumns = withoutQuoNo.map((col) => {
    const isLegacyTypeCol =
      col?.name === 'VR Type' ||
      col?.lable === 'VR Type' ||
      col?.name === 'Vr Type' ||
      col?.lable === 'Vr Type';

    if (isLegacyTypeCol) {
      return { ...col, lable: 'Type', name: 'Type' };
    }
    return col;
  });

  const hasVrType = renamedColumns.some(
    (col) => col?.name === 'VR Type' || col?.lable === 'VR Type'
  );

  let withVrType = renamedColumns;
  if (!hasVrType) {
    const refIndex = renamedColumns.findIndex(
      (col) => col?.name === 'Ref No.' || col?.lable === 'Ref No.'
    );
    const vrTypeCol = {
      lable: 'VR Type',
      name: 'VR Type',
      class: '',
      sort: 1,
      status: true,
    };

    withVrType =
      refIndex === -1
        ? [...renamedColumns, vrTypeCol]
        : [
            ...renamedColumns.slice(0, refIndex),
            vrTypeCol,
            ...renamedColumns.slice(refIndex),
          ];
  }

  const hasCustomer = withVrType.some(
    (col) => col?.name === 'Customer' || col?.lable === 'Customer'
  );

  if (hasCustomer) return withVrType;

  const refIndex = withVrType.findIndex(
    (col) => col?.name === 'Ref No.' || col?.lable === 'Ref No.'
  );
  const customerCol = {
    lable: 'Customer',
    name: 'Customer',
    class: '',
    sort: 1,
    status: true,
  };

  if (refIndex === -1) return [...withVrType, customerCol];

  return [
    ...withVrType.slice(0, refIndex + 1),
    customerCol,
    ...withVrType.slice(refIndex + 1),
  ];
};
